import {shoppingCart, renderCart, processCartOrderPaymentRequest, getCurrency} from './cart'
import {FbPixelTrackInitiateCheckoutEvent} from './pixels'
import {activateSpinnerModal, activateMoMoSpinnerModal, deactivateSpinnerModal, deactivateMoMoSpinnerModal, deactivateReadySpinnerModal, coordinateModalShowBody, coordinateModalShowBodyReset, initializeModalControls} from './modals-control'
import './gifts'


// Dom and resources like images and iframes, are ready when load event fires
// Don't wait for potentially slow external resources which fires load event on windows later
document.addEventListener("DOMContentLoaded", function() {
// window.addEventListener('load', function() { //This caused issue when network delays and some external scripts like facebook event was not fully loaded
    renderCart();
    console.log('Cart is loaded')

    // Deactivate Getting Ready... Spinner on Services page load
    deactivateReadySpinnerModal();


    /* Payment Buttons */

    Array.from(document.getElementsByClassName('init-payment')).forEach(el => {
      // console.log("=================Adding payment init-payment event handlers=================")
      el.addEventListener('click', handleInitPaymentEvent)
    });

    // Get all modals and attach their event listeners
    initializeModalControls();


})


async function handleInitPaymentEvent(e) {
  // Disable scrolling on document body (function displays a spinner modal)
  // TODO: Maybe display Mobile Money payment instructions to spinner
  // Have special spinner activate based on the gateway and currency
  coordinateModalShowBody()

  // Disable element for network request
  e.currentTarget.disabled = true
  // Keep a Copy of current Event Target
  let currentEventTarget = e.currentTarget 

  let gateway = e.currentTarget.getAttribute('data-gateway')

  // https://byexample.xyz/javascript/tryCatchThrow/
  try {
    // Network requests might trigger an error (though already handled)

    // console.log("about to cordinate active spinner modal")
    coordinateActivateSpinnerModal(gateway)

    // console.log("about to send tracking pixels to fb")

    /*******************************
    *******************************/
    // Cool place to report InitiateCheckout Event
    // This fbq code is added globally, so see if we can target it here without importing a module
    FbPixelTrackInitiateCheckoutEvent()
    /*******************************
    *******************************/

    // console.log("calling on backend to process cart order")
    // Call function
    await processCartOrderPaymentRequest(e) 
    
    
  } catch (error) {
    // Only runs when there is an error/exception

  } finally {
    // Code here always runs. Doesn't matter if there was an error or not.
    
    // Hide Spinner No Matter What, if gateway is bank
    if (gateway.includes("bank")) {
      modalBodyDisplayReset()
      // Re-Enable Button
      currentEventTarget.disabled = false;
    } else {
      setTimeout(function(){
        modalBodyDisplayReset()
        currentEventTarget.disabled = false; //closure here, but check for errors
      }, 10000) // 10 seconds
    }

  }

}


export function isMobilMoneyCurrency() {
  let currency = getCurrency()
  if (currency == "GHS" 
    || currency == "KES"
    || currency == "RWF" 
    || currency == "XAF" 
    || currency == "XOF" 
    || currency == "UGX" 
    || currency == "TZS" 
    || currency == "MWK" 
  ) {
    console.log("is mobile money currency: ", currency)
    return true
  }
  return false
}

export function getCountryDailingCodeByMobileMoneyCurrency() {
  let currency = getCurrency()
  return getDialingCodesByCurrency(currency)
}

export function getMobileMoneyCountryCode() {
  let currency = getCurrency()


  console.log("is mobile money currency: ", currency)
  if (currency == "GHS") {
    return "233"
  } else if (currency == "KES") {
    return "254"
  } else if (currency == "RWF") {
    return "250"
  }else if (currency == "XAF") {
    return "250" // complicated (many countries)
  }else if (currency == "XOF") {
    return "250" // complicated (many countries)
  }else if (currency == "UGX") {
    return "256"
  }else if (currency == "TZS") {
    return "255"
  }else if (currency == "MWK") {
    return "265"
  }else {
    return "1"
  } 
  return false
}


// Example usage:
// const dialingCodeForKenya = getDialingCodeByCountryCode("KE");
// console.log(dialingCodeForKenya); // Output: "254"

export function getDialingCodeByCountryCode(countryAlpha2Code) {
  const countries = getMobileMoneyCountryData();

  // Find the country by its alpha2 code
  const country = countries.find(country => country.country_alpha2_code === countryAlpha2Code);

  // Return the dialing code if the country is found, otherwise return ""
  if (country) {
    return country.dialing_code;
  } else {
    console.log(`Country code ${countryAlpha2Code} not found.`);
    return ""
  }
}

// Example usage:
// const dialingCodeForKenya = getDialingCodeByCountryCode("KE");
// console.log(dialingCodeForKenya); // Output: "254"


export function getDialingCodesByCurrency(currencyCode) {
  const countries = getMobileMoneyCountryData();

  // Filter countries by the given currency code
  const filteredCountries = countries.filter(country => country.currency_code === currencyCode);

  // Extract the dialing codes and join them as a comma-separated string
  const dialingCodes = filteredCountries.map(country => country.dialing_code).join(", ");

  return dialingCodes;
}

// Example usage:
// const dialingCodesUsingXOF = getDialingCodesByCurrency("XOF");
// console.log(dialingCodesUsingXOF); // Output: "229, 226, 225, 223, 227, 221, 228"


export function getCountryCodesByCurrency(currencyCode) {
  const countries = getMobileMoneyCountryData();

  // Filter countries by the given currency code
  const filteredCountries = countries.filter(country => country.currency_code === currencyCode);

  // Extract the country codes and join them as a comma-separated string
  const countryCodes = filteredCountries.map(country => country.country_alpha2_code).join(", ");

  return countryCodes;
}

// Example usage:
// const countryCodesUsingXOF = getCountryCodesByCurrency("XOF");
// console.log(countryCodesUsingXOF); // Output: "BJ, BF, CI, ML, NE, SN, TG"



export function coordinateActivateSpinnerModal(gateway) {
  gateway = gateway.trim()
  console.log(gateway)
  if (gateway == "flutterwave" && isMobilMoneyCurrency()) {
    console.log("is mobile money spinner, for gateway:", gateway)
    let momoCountryDialingCodeSpan = document.getElementById("momo-country-dailing-code")
    let dailingCodes = getCountryDailingCodeByMobileMoneyCurrency()
    if (momoCountryDialingCodeSpan !== null) {
      momoCountryDialingCodeSpan.innerText = dailingCodes
    }
    activateMoMoSpinnerModal()
  } else {
    activateSpinnerModal()
  }
}


export function modalBodyDisplayReset() {
  deactivateSpinnerModal()
  deactivateMoMoSpinnerModal()
  coordinateModalShowBodyReset()
}

export function getMobileMoneyCountryData() {
  return [
    { country: "Benin", country_alpha2_code: "BJ", country_dialing_code: "+229", dialing_code: "229", currency_code: "XOF" }, // Benin (CFA Franc)
    { country: "Burkina Faso", country_alpha2_code: "BF", country_dialing_code: "+226", dialing_code: "226", currency_code: "XOF" }, // Burkina Faso (CFA Franc)
    { country: "Côte d'Ivoire", country_alpha2_code: "CI", country_dialing_code: "+225", dialing_code: "225", currency_code: "XOF" }, // Côte d'Ivoire (CFA Franc)
    { country: "Guinea-Bissau", country_alpha2_code: "GW", country_dialing_code: "+245", dialing_code: "245", currency_code: "XOF" }, // Guinea-Bissau (CFA Franc)
    { country: "Mali", country_alpha2_code: "ML", country_dialing_code: "+223", dialing_code: "223", currency_code: "XOF" }, // Mali (CFA Franc)
    { country: "Niger", country_alpha2_code: "NE", country_dialing_code: "+227", dialing_code: "227", currency_code: "XOF" }, // Niger (CFA Franc)
    { country: "Senegal", country_alpha2_code: "SN", country_dialing_code: "+221", dialing_code: "221", currency_code: "XOF" }, // Senegal (CFA Franc)
    { country: "Togo", country_alpha2_code: "TG", country_dialing_code: "+228", dialing_code: "228", currency_code: "XOF" }, // Togo (CFA Franc)
    { country: "Cameroon", country_alpha2_code: "CM", country_dialing_code: "+237", dialing_code: "237", currency_code: "XAF" }, // Cameroon (CFA Franc)
    { country: "Central African Republic", country_alpha2_code: "CF", country_dialing_code: "+236", dialing_code: "236", currency_code: "XAF" }, // Central African Republic (Central African CFA Franc)
    { country: "Chad", country_alpha2_code: "TD", country_dialing_code: "+235", dialing_code: "235", currency_code: "XAF" }, // Chad (Central African CFA Franc)
    { country: "Republic of the Congo", country_alpha2_code: "CG", country_dialing_code: "+242", dialing_code: "242", currency_code: "XAF" }, // Republic of the Congo (Central African CFA Franc)
    { country: "Equatorial Guinea", country_alpha2_code: "GQ", country_dialing_code: "+240", dialing_code: "240", currency_code: "XAF" }, // Equatorial Guinea (Central African CFA Franc)
    { country: "Gabon", country_alpha2_code: "GA", country_dialing_code: "+241", dialing_code: "241", currency_code: "XAF" }, // Gabon (Central African CFA Franc)
    { country: "Rwanda", country_alpha2_code: "RW", country_dialing_code: "+250", dialing_code: "250", currency_code: "RWF" }, // Rwanda (Rwandan Franc)
    { country: "Ghana", country_alpha2_code: "GH", country_dialing_code: "+233", dialing_code: "233", currency_code: "GHS" }, // Ghana (Ghanaian Cedi)
    { country: "Kenya", country_alpha2_code: "KE", country_dialing_code: "+254", dialing_code: "254", currency_code: "KES" }, // Kenya (Kenyan Shilling)
    { country: "Uganda", country_alpha2_code: "UG", country_dialing_code: "+256", dialing_code: "256", currency_code: "UGX" }, // Uganda (Ugandan Shilling)
    { country: "Tanzania", country_alpha2_code: "TZ", country_dialing_code: "+255", dialing_code: "255", currency_code: "TZS" }, // Tanzania (Tanzanian Shilling)
    { country: "Malawi", country_alpha2_code: "MW", country_dialing_code: "+265", dialing_code: "265", currency_code: "MWK" }  // Malawi (Malawian Kwacha)
  ];
  
}

module.exports = {
  shoppingCart, renderCart
};




  